<template>
  <div id="Home">
    <Carousel />
    <CoreStory />
    <Parallax />
    <OriginStory />
    <ArtStory />
    <Gallery />
    <News />
    <Position />
  </div>
</template>

<script>
// @ is an alias to /src
import Carousel from "@/components/Home/HomeTopCarousel"
import CoreStory from '@/components/Home/HomeCoreStory'
import Parallax from '@/components/Home/HomeParallax'
import OriginStory from '@/components/Home/HomeOriginStory'
import ArtStory from '@/components/Home/HomeArtStory'
import Gallery from '@/components/Home/HomeGallery'
import News from '@/components/Home/HomeNews'
import Position from '@/components/Home/HomePosition'

export default {
  name: 'Home',
  components: {
    CoreStory,
    Carousel,
    Parallax,
    OriginStory,
    ArtStory,
    Gallery,
    News,
    Position
  }
}
</script>
